// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pZ3tymgEwyRoaELsFylE{padding:30px 0 10px}.pZ3tymgEwyRoaELsFylE .AMU1zu_tcD237afHpdfP{margin-bottom:20px}`, "",{"version":3,"sources":["webpack://./src/App/views/SchoolDataRoleSelection/SchoolDataRoleSelection.module.scss"],"names":[],"mappings":"AAAA,sBAAe,mBAAmB,CAAC,4CAA6B,kBAAkB","sourcesContent":[".checkboxGroup{padding:30px 0 10px}.checkboxGroup .checkboxItem{margin-bottom:20px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxGroup": `pZ3tymgEwyRoaELsFylE`,
	"checkboxItem": `AMU1zu_tcD237afHpdfP`
};
export default ___CSS_LOADER_EXPORT___;
